import BaseCommunicator from "./BaseCommunicator"

class BrowserCommunicator extends BaseCommunicator {
    getLocale() {
        return null;
    }

    getConfig() {
        return null;
    }

    getMeinJenaUser() {
        return new Promise((resolve, reject) => {
            resolve();
        });
    }

    openEmail() {
        return null;
    }

    setPageTitle(data) {
        console.log(data);
    }

    refreshToken() {
        return null;
    }

    reportError(title, message) {
        if (typeof title === "object") {
            message = title.message;
            title = title.title;
        }
        alert(message);
    }

    openExternalBrowser(url) {
        window.open(url, "_blank");
    }

    openInternalBrowser(url, title, showShareButton, showNavigationButtons, showCrossBackNavigationAndroid, isNavWhite) {
        location.href = url;
    }

    trackPageImpression(pageName) {
        console.log("Track page impression", pageName);
        return null;
    }

    trackEvent(action, category, label) {
        console.log("Track event", action, category, label);
        return null;
    }
}

export default BrowserCommunicator;
